// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-theme-input .form-control {
  background-color: var(--bs-body-bg) !important;
  color: #e0e0e0 !important;
  border: 1px solid var(--bs-border-color) !important;
}

.dark-theme-input .form-control::placeholder {
  color: #fff !important;
}

.dark-theme-input .form-control:focus {
  border-color: #6200ea !important;
  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;
}

.dark-select__menu {
  background-color: #1f1f1f !important;
  color: #e0e0e0 !important;
}

.dark-select__option {
  background-color: #1f1f1f !important;
  color: #e0e0e0 !important;
}

.dark-select__option--is-selected {
  background-color: #6200ea !important;
  color: #fff !important;
}

.dark-select__option--is-focused {
  background-color: #333 !important;
}

.dark-select__single-value {
  color: #fff !important;
}

.dark-select__input-container {
  color: #fff !important;
}

/* Form elements styling */
.radio-options {
  display: flex;
  justify-content: flex-start;
  margin-left: 160px;
}

.option-check label {
  width: auto !important;
  margin-right: 20px !important;
  text-align: left !important;
}

/* Diode toggle styling */
.toggle-container {
  padding: 8px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 4px;
  width: 100%;
}

.toggle-container .form-check {
  margin-bottom: 0;
}

/* Drag and drop container styling */
.drag-drop-container {
  border: 2px dashed #60606080;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  margin-bottom: 20px;
  width: 100%;
}

.drag-drop-container:hover {
  border-color: #9966CC;
  background-color: rgba(153, 102, 204, 0.05);
}

.drag-drop-container.dragging {
  border-color: #9966CC;
  background-color: rgba(153, 102, 204, 0.1);
}

.drag-drop-container input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.upload-icon {
  color: #9966CC;
  font-size: 48px;
  margin-bottom: 15px;
}

.drag-drop-text {
  font-size: 24px;
  margin-bottom: 10px;
  color: #fff;
}

.drag-drop-subtext {
  color: #aaa;
  margin-bottom: 10px;
}

/* Rearrange section styling */
.rearrange-section h5 {
  margin-top: 30px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 10px;
}

.rearrange-section {
  position: relative;
}

.rearrange-sticky-container {
  background-color: rgba(20, 20, 20, 0.98);
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.original-rearrange {
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.sticky-rearrange {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 40%;
  max-width: 500px;
  z-index: 1000;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddOrEditCRT.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf","sourcesContent":[".dark-theme-input .form-control {\n  background-color: var(--bs-body-bg) !important;\n  color: #e0e0e0 !important;\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.dark-theme-input .form-control::placeholder {\n  color: #fff !important;\n}\n\n.dark-theme-input .form-control:focus {\n  border-color: #6200ea !important;\n  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;\n}\n\n.dark-select__menu {\n  background-color: #1f1f1f !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-select__option {\n  background-color: #1f1f1f !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-select__option--is-selected {\n  background-color: #6200ea !important;\n  color: #fff !important;\n}\n\n.dark-select__option--is-focused {\n  background-color: #333 !important;\n}\n\n.dark-select__single-value {\n  color: #fff !important;\n}\n\n.dark-select__input-container {\n  color: #fff !important;\n}\n\n/* Form elements styling */\n.radio-options {\n  display: flex;\n  justify-content: flex-start;\n  margin-left: 160px;\n}\n\n.option-check label {\n  width: auto !important;\n  margin-right: 20px !important;\n  text-align: left !important;\n}\n\n/* Diode toggle styling */\n.toggle-container {\n  padding: 8px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.1);\n  margin-top: 4px;\n  width: 100%;\n}\n\n.toggle-container .form-check {\n  margin-bottom: 0;\n}\n\n/* Drag and drop container styling */\n.drag-drop-container {\n  border: 2px dashed #60606080;\n  border-radius: 8px;\n  padding: 30px;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.drag-drop-container:hover {\n  border-color: #9966CC;\n  background-color: rgba(153, 102, 204, 0.05);\n}\n\n.drag-drop-container.dragging {\n  border-color: #9966CC;\n  background-color: rgba(153, 102, 204, 0.1);\n}\n\n.drag-drop-container input[type=\"file\"] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.upload-icon {\n  color: #9966CC;\n  font-size: 48px;\n  margin-bottom: 15px;\n}\n\n.drag-drop-text {\n  font-size: 24px;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n.drag-drop-subtext {\n  color: #aaa;\n  margin-bottom: 10px;\n}\n\n/* Rearrange section styling */\n.rearrange-section h5 {\n  margin-top: 30px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 10px;\n}\n\n.rearrange-section {\n  position: relative;\n}\n\n.rearrange-sticky-container {\n  background-color: rgba(20, 20, 20, 0.98);\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n\n.original-rearrange {\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.sticky-rearrange {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  width: 40%;\n  max-width: 500px;\n  z-index: 1000;\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
